import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import CheckoutBreadcrumbs from "./CheckoutBreadcrumbs";
import { getCheckout, setCheckout } from "../utils/buyNowStorage";
import api from "../api/axios";
const OrderSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const checkout = getCheckout();
  // const address = location.state?.address;
const addressId = location.state?.addressId;
const [address, setAddress] = React.useState(null);

  useEffect(() => {
    if (!checkout?.items?.length) {
      navigate("/", { replace: true });
      return;
    }

  if (!addressId) {
      navigate("/delivery-location", { replace: true });
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.username) {
            navigate("/login");
            return;
          }
  api.get(`/users/${user.username}/addresses/${addressId}`)
    .then((res) => {
      setAddress(res.data.address);
      setCheckout({ ...checkout, addressId });
    })
    .catch(() => {
      navigate("/delivery-location", { replace: true });
    });
//     const found = user?.addresses?.find(
//       (a) => a._id === addressId
//     );
// console.log("Found address:", found);
//        if (!found) {
//       navigate("/delivery-location", { replace: true });
//       return;
//     }
//     setAddress(found);

//     setCheckout({ ...checkout, addressId  });
  }, [addressId ]);

  if (!checkout || !address) return null;

  const subtotal = checkout.items.reduce(
    (sum, i) => sum + i.price * i.qty,
    0
  );
  const shipping = subtotal > 500 ? 0 : 49;
  const total = subtotal + shipping;

  return (
    <Box sx={{ maxWidth: 600, mx: "auto",  p: 2 }}>
      <CheckoutBreadcrumbs active={1} />

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={700}>
          Order Summary
        </Typography>

        {checkout.items.map((item, i) => (
          <Box key={i} sx={{ my: 2 }}>
            <Typography fontWeight={600}>{item.title}</Typography>
            <Typography>Qty: {item.qty}</Typography>
            <Typography>₹{Number(item.price * item.qty).toLocaleString("en-IN")}</Typography>
          </Box>
        ))}

        <Divider sx={{ my: 2 }} />
        <Typography>
          Subtotal: ₹ {Number(subtotal).toLocaleString("en-IN")}
          {/* Subtotal: ₹{subtotal} */}
          
        </Typography>
        <Typography>Shipping: ₹{Number(shipping).toLocaleString("en-IN")}</Typography>
        <Typography fontWeight={700}>Total: ₹{Number(total).toLocaleString("en-IN")}</Typography>

        <Divider sx={{ my: 2 }} />

        <Typography fontWeight={600}>Deliver to:</Typography>
        <Typography>
          {address.addressLine1}, {address.city} - {address.pincode}
        </Typography>

        <Button
          fullWidth
          sx={{ mt: 3 }}
          variant="contained"
          onClick={() => navigate("/payment")}
        >
          Proceed to Payment
        </Button>
      </Paper>
    </Box>
  );
};

export default OrderSummary;
